export const storyData = [
   "606 Academy is more than basketball—it’s a story of resilience, purpose, and community.",

   "Founded by U.S. Marine Corps veteran Coach Greg, 606 Academy began as a personal mission to give back. After serving his country and exploring a path in education, Greg found his calling through youth sports—starting as a part-time coach and growing into a full-time passion.",
   
   "He built 606 from the ground up, often driving rideshare between practices and facing obstacles like lost gym space and limited resources. But his vision never wavered: create a place where kids feel purpose, belonging, and opportunity.",
   
   "With guidance from mentors like Jarryd Loyd and Ismaila Kane, and a turning point supported by WNBA star Jewell Loyd, 606 Academy became more than a program—it became a movement. A gifted American flag, once forgotten in an attic, now symbolizes the hope and legacy behind it all.",
   
   "Today 606 Academy is a 501(c)(3) nonprofit teaching leadership, service, and self-belief through all sports and beyond.",
   
   "Every child deserves a chance to succeed—no matter their background.",
   "Welcome to 606 Academy."
]

export const logoData = [
   "The shield symbolizes protection, safety, and strength, reflecting our commitment to providing a safe space where kids can grow physically and emotionally.",

"3 stars on the outside honor the new members of the 606 legacy. The 4th star represents future hopes and dreams of every child we guide toward a brighter future.",

"The center star represents the sun, reminding us all  that we are one.",

"The meaning behind the angel number 606 aligns perfectly with our mission to empower athletes and Inspire future leaders. The number symbolizes striving for balance and harmony, which we foster by supporting our athletes in all aspects of life—home, relationships, education, and personal growth."

]
